import { entraLogout } from 'Components/Auth';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { actions } from '../../Data/ReduxViewModels/Authentication';
import { Button, ButtonGroup } from '../Core';
import { PageSection } from '../Layout';

const LogOutSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isEntraInitialised = useSelector((state) => state.authentication.entra.isInitialised);

  return (
    <PageSection heading="Log Out of the QEST Web App">
      <p>To log out of the QEST Web App, click the button below.</p>
      <ButtonGroup>
        <Button
          primary
          onClick={() => {
            dispatch(actions.postLogout());
            if (isEntraInitialised) entraLogout();
            navigate('/');
          }}
        >
          Log Out
        </Button>
      </ButtonGroup>
    </PageSection>
  );
};

export default LogOutSection;
